export const getMessage = (shop_name) => {
  return `${shop_name}
ご担当者様

お世話になっております。

注文書を添付ファイルにてお送りいたします。
ご査収のほどよろしくお願いいたします。`;
};
export const getSubject = (shop_name) => {
  return `【発注依頼】${shop_name} 様`;
};
